import NotFound from "../components/Error/NotFound/404";
import EntryHome from "../pages/Entry";
import notFoundRoute from "./not-found.route";
import TesterRecompensas from "../pages/Tester";
import FinancialTest from "../pages/Tester/QuestionTest";
import CreateColaboratorAccount from "../pages/Entry/Colaborator/createColaborator";
import Home from "../pages/Colaborator/ladingRetos";
import AlfabetizacionFinanciera from "../pages/Colaborator/alfabetizacionFananciera";

const entryRoutes = [
  {
    path: "/",
    component: <Home />,
    exact: true,
  },
  {
    path: "/login",
    component: <EntryHome />,
    exact: true,
  },
  {
    path: "/alfabetizacion-bancaria",
    component: <AlfabetizacionFinanciera />,
    exact: true,
  },
  {
    path: "/create/user",
    component: <CreateColaboratorAccount />,
    exact: true,
  },
  {
    path: "/404",
    component: <NotFound />,
  },
  {
    path: "/tester",
    component: <TesterRecompensas />,
  },
  {
    path: "/questions-test",
    component: <FinancialTest />,
  },
  notFoundRoute,
];

export default entryRoutes;
